export default "__VITE_ASSET__ca8df422__"